import baseUrlPathImage from "../API/baseUrlPathImage";


const ImageSrc = (url?: string | null) => {
  if (url && url.trim() !== "") {
    const image = `${baseUrlPathImage.test}${url}`;
  
    return <img src={image} alt="Preview" width="200" />;
  }

  return null;
}
export default ImageSrc